module.exports = __webpack_public_path__ + "static/media/more.e3d0151e.svg";